import {useParams} from "react-router-dom";
import {BoardContainer, TitleContainer} from "../../assets/GlobalStyles";
import Notice from "./Notice";
import Inquiry from "./Inquiry";
import React from "react";
import NoticeDetail from "./NoticeDetail";
import InquiryDetail from "./InquiryDetail";

export default function Customer() {
  const params = useParams();
  return (
      <main>
        <BoardContainer>
          <TitleContainer>
            <h1>고객 센터</h1>
          </TitleContainer>
          {params.id === 'notice' && <Notice/>}
          {params.id === 'noticeDetail' && <NoticeDetail/>}
          {params.id === 'inquiry' && <Inquiry/>}
          {params.id === 'inquiryDetail' && <InquiryDetail/>}
        </BoardContainer>
      </main>
  )
}
